/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { cluster_id } from '../models/cluster_id';
import type { GetStatisticsResponseOkDto } from '../models/GetStatisticsResponseOkDto';
import type { session_id } from '../models/session_id';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class StatisticsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get a list of statistics
     * Get a list of statistics. (Access: admin, director)
     * @returns GetStatisticsResponseOkDto Statistics list
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getStatistics({
        clusterId,
        sessionIds,
        startDate,
        endDate,
    }: {
        clusterId: cluster_id,
        /**
         * Array of session ids
         */
        sessionIds?: Array<session_id>,
        /**
         * Lower bound for date
         */
        startDate?: string,
        /**
         * Upper bound for date
         */
        endDate?: string,
    }): CancelablePromise<GetStatisticsResponseOkDto | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/statistics',
            query: {
                'cluster_id': clusterId,
                'session_ids': sessionIds,
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
}
